import { render, staticRenderFns } from "./orderFlow.vue?vue&type=template&id=1b4f9738"
import script from "./orderFlow.vue?vue&type=script&lang=js"
export * from "./orderFlow.vue?vue&type=script&lang=js"
import style0 from "./orderFlow.vue?vue&type=style&index=0&id=1b4f9738&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports